/** vendor */
import React, { useState } from 'react'

/** components */
import { Card } from '../../components/UI/Card'
import IngredientsTab from '../../components/Learn/IngredientsTab'
import TechniquesTab from '../../components/Learn/TechniquesTab'
import TutorialsTab from '../../components/Learn/TutorialsTab'

export default function LearnLanding() {
  const [tab, setTab] = useState('ingredients')

    const handleToggleTab = (e) => {
        e.preventDefault()
        setTab(e.target.href.split('#')[1])
    }

    return (
        <div className="pt-12 md:max-w-4xl w-full">
            <Card title="learn"> 
                <div>
                    <ul className="z-50 w-full border-b-2 border-an_orange-dark flex justify-center flex-wrap text-sm font-medium bg-an_white-dark text-center sticky p-2 pb-0 left-0 top-0">
                        <li className="w-1/3 text-center">
                            <a 
                                href="#ingredients" 
                                aria-current="page"
                                onClick={handleToggleTab}
                                className={`${tab === 'ingredients' 
                                    ? 'active bg-an_orange text-border-orange border border-an_orange-dark border-b-0 text-an_white'
                                    : 'text-an_orange-dark'} block py-1 px-2 rounded-t  border-transparent border border-b-0`
                                }   
                            >
                                Ingredients
                            </a>
                        </li>
                        <li className="w-1/3 text-center">
                            <a 
                            href="#techniques"
                            onClick={handleToggleTab} 
                            className={`${tab === 'techniques' 
                                ? 'active bg-an_orange text-border-orange border border-an_orange-dark border-b-0 text-an_white'
                                : 'text-an_orange-dark'} block py-1 px-2 rounded-t  border-transparent border border-b-0`
                            }  
                            >
                                techniques
                            </a>
                        </li>
                        <li className="w-1/3 text-center">
                            <a 
                            href="#tutorials"
                            onClick={handleToggleTab} 
                            className={`${tab === 'tutorials' 
                                ? 'active bg-an_orange text-border-orange border border-an_orange-dark border-b-0 text-an_white'
                                : 'text-an_orange-dark'} block py-1 px-2 rounded-t  border-transparent border border-b-0`
                            }
                            >
                            tutorials
                            </a>
                        </li>
                    </ul>
                    <>
                        { tab === 'ingredients' && <IngredientsTab /> }
                        { tab === 'techniques' && <TechniquesTab /> }
                        { tab === 'tutorials' && <TutorialsTab /> }
                    </>
                </div>
            </Card>
        </div>
    )
}